export const tokens = {
  colors: {
    primary: '#155FA2',
    primaryDark: '#1261a0',
    accent: '#B0153C',
    pageBackground: '#ECF1F9',
    fieldsetBorder: '#d3d3d375',
    fieldsetBackground: '#ffffff95',
  },
  radii: {
    s: '5px',
  },
  touch: {
    min: '44px',
  },
} as const;

export type Tokens = typeof tokens;
